module.exports = __webpack_public_path__ + "img/4.71d2ed51.png";